import Client from '@akumzy/dedupe-upload'

let newclient = process.env.NODE_ENV === 'development' ? new Client('wss://192.168.1.2:4444/ws') : new Client(process.env.VUE_APP_FILE_UPLOAD)

export default newclient
